import { useState, useEffect } from 'react';
import 'react-tabs/style/react-tabs.css';
import 'moment/locale/pt-br';

import { Stack, Button } from '@mui/material';

/* hooks */
import { useNavigateParams } from '../../../hooks/useNavigateParams';

import DataList from '../../form/DataList';
import Checkbox from '../../form/Checkbox';
import SelectEmpresa from '../../form/SelectEmpresa';

/* api */
import * as DataListAPI from '../../../api/dataList';

function Form({
    token,
    dados,
    setDados,
    //tabelas filhas
    pessoa,
    setPessoa,
    empresaId,
    empresaIds,

    handleSubmit,

    btnText,
    caminhoVoltar,
    OptionsEmpresa,
}) {
    const navigate = useNavigateParams();

    //set datalist
    const [OptionsPessoa, setOptionsPessoa] = useState(dados?.Pessoa || []);

    // params => empresaId, tabela, id, descricao, condicao, filtro, operacao, funcionarioId
    const consultaDatalist = async (params) => {
        try {
            return await DataListAPI.dataList(params);
        } catch (error) {
            console.error('Erro ao consultar DataList:', error);
            throw error;
        }
    };

    async function handleChange(e) {
        const { name, value, checked, type } = e.target;

        if (name === 'ativo') {
            setDados({ ...dados, [name]: checked });
        } else if (name === 'pessoa.descricao') {
            setPessoa({
                ...pessoa,
                [name.split('.')[1]]: value,
            });

            //carrega o datalist
            const result = await consultaDatalist({
                empresaId: dados.empresaId,
                tabela: 'Pessoa',
                condicao: 'pessoaUsuario',
                filtro: value,
            });
            setOptionsPessoa(result);

            const selectedId = document.querySelector(`datalist option[value="${value}"]`)?.dataset.id;
            setDados({
                ...dados,
                pessoaId: selectedId ?? null,
            });
        } else {
            setDados({ ...dados, [name]: value });
        }
    }

    async function handleOnBlur(e) {}
    async function handleOnFocus(e) {}

    const submit = (e) => {
        e.preventDefault();

        handleSubmit(dados);
    };

    return (
        <form onSubmit={submit}>
            <h1>Pessoa x Empresa</h1>
            <div>
                <DataList
                    text="Pessoa"
                    title={'Seleciona a pessoa'}
                    name="pessoa.descricao"
                    inputWidth="300px"
                    filteredOptions={OptionsPessoa}
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={pessoa.descricao || ''}
                />
                <SelectEmpresa
                    text="Selecione a Empresa"
                    name="empresaId"
                    inputWidth="300px"
                    options={OptionsEmpresa}
                    handleOnChange={handleChange}
                    handleOnFocus={handleOnFocus}
                    handleOnBlur={handleOnBlur}
                    value={dados.empresaId || ''}
                    required
                    notOptNull={true}
                />

                <Checkbox
                    title="Ativa quando marcado"
                    text="Ativo"
                    name="ativo"
                    handleOnChange={handleChange}
                    value={dados.ativo}
                    checked={!!dados.ativo}
                />
            </div>
            <div>
                <Stack direction="row" spacing={1}>
                    <Button variant="contained" color="secondary" onClick={() => navigate(caminhoVoltar)}>
                        Voltar
                    </Button>
                    <Button type="submit" variant="contained" color="success">
                        {btnText}
                    </Button>
                </Stack>
            </div>
        </form>
    );
}
export default Form;
